import t from "./EditorEmptyState.vue2.js";
import o from "../_virtual/_plugin-vue_export-helper.js";
const r = /* @__PURE__ */ o(t, [["__scopeId", "data-v-353a8ff8"]]);
export {
  r as default
};
